import angular from 'angular';
import uiRouter from 'angular-ui-router';
import HomeController from './home.controller';
import HomeTemplate from './home.template.html';
// Directives
import TitreBandeau from '../../components/titre-bandeau/titre-bandeau.component';
import Historique from '../../components/historique/historique.component';
import NotreAction from '../../components/notre-action/notre-action.component';
import MotPresident from '../../components/mot-president/mot-president.component';
import Membres from '../../components/membres/membres.component';
import Dons from '../../components/dons/dons.component';

angular
  .module('app.home', [
    'ui.router'
  ])
  .config(($stateProvider, $locationProvider) => {
    $locationProvider.html5Mode(true);
    $stateProvider
      .state('home', {
        url: '/home',
        views: {
          app: {
            template: HomeTemplate,
            controller: HomeController,
            controllerAs: 'home'
          }
        }
      })
  })


// WEBPACK FOOTER //
// ./src/app/pages/home/home.js